<section class="about-page py-5">
  <div class="container">
    <div class="about-hero">
      <div>
        <p class="eyebrow mb-2">About Upcoming Cars</p>
        <h1 class="mb-3">Built to simplify future car discovery</h1>
        <p class="mb-0">
          At <a routerLink="/home">Upcoming Cars</a>, we help drivers and enthusiasts
          discover new launches, compare models, and choose future-ready vehicles with confidence.
        </p>
      </div>
      <div class="hero-proof" aria-label="Upcoming Cars customer promise">
        <strong>Future</strong>
        <span>ready car discovery</span>
      </div>
    </div>

    <div class="about-stat-grid mt-4" aria-label="Operating principles">
      <article>
        <strong>Fast</strong>
        <span>Launch timeline insights</span>
      </article>
      <article>
        <strong>Clear</strong>
        <span>Model and pricing context</span>
      </article>
      <article>
        <strong>Guided</strong>
        <span>Shortlist clarity</span>
      </article>
    </div>

    <div class="content-card mt-4">
      <h3>Why We Started</h3>
      <p>
        Upcoming vehicle research is often scattered across brand sites, rumors, reviews, and pricing updates.
        Upcoming Cars brings launches, EV insights, luxury models, and comparisons into one elegant experience.
      </p>

      <h3 class="mt-4">What We Offer</h3>
      <div class="pill-grid">
        <span>Upcoming Launch Tracking</span>
        <span>EV Range Insights</span>
        <span>Luxury Model Discovery</span>
        <span>Vehicle Comparison</span>
        <span>Price & Launch Monitoring</span>
        <span>Expert Buying Guidance</span>
      </div>

      <div class="principle-grid mt-4">
        <article>
          <span class="principle-icon">01</span>
          <h4>Responsive by default</h4>
          <p>Every screen is designed around fast decisions on desktop, tablet, and mobile.</p>
        </article>
        <article>
          <span class="principle-icon">02</span>
          <h4>Action over clutter</h4>
          <p>Drivers see the next useful insight instead of sorting through noisy automotive pages.</p>
        </article>
        <article>
          <span class="principle-icon">03</span>
          <h4>Trust through visibility</h4>
          <p>Launch status, vehicle fit, and comparison context stay visible across the journey.</p>
        </article>
      </div>

      <h3 class="mt-4">Our Vision</h3>
      <blockquote>No future car should be hard to discover.</blockquote>
      <p class="mb-0">Built for the future of automotive discovery — clarity, confidence, and excitement.</p>
    </div>
  </div>
</section>
